import types from './types'

const setToken = (commit, token) => {
  if (token) {
    commit(types.SET_TOKEN, token)
  } else {
    throw new Error('invalid auth token')
  }
}

const setUser = (
  commit,
  {
    id = null,
    type = null,
    email = null,
    first_name = null,
    last_name = null,
    permissions = []
  }
) => {
  commit(types.SET_USER, {
    id,
    type,
    email,
    firstName: first_name,
    lastName: last_name,
    permissions
  })
}

const updateState = ({ commit }, { token = null, user = {} }) => {
  try {
    setToken(commit, token)
    setUser(commit, user)
  } catch (err) {
    throw new Error('invalid auth data')
  }
}

export default {
  [types.UPDATE_DATA]: updateState
}
